import React, { useEffect, useState, useContext } from 'react'
import UserTableView from '@/product/components/organisms/User/TableView'
import { Button } from '@mui/material'
import Layout from '../../product/components/templates/Layout'
import DynamicContext from '@/product/context/dynamic/dynamicContext'
import ReportContext from '@/product/context/report/reportContext'
import OrgManage from './OrgManage'
import { handleRedirectInternal } from '@/product/common/components'
import { useHistory } from 'react-router-dom'

const UserCommon = (props) => {
    const dynamicContext = useContext(DynamicContext)
    const history = useHistory()
    const { user_tablefields, user_dynamicfields } = dynamicContext

    const { getAllExportDownload } = useContext(ReportContext)

    const [manage, setManage] = useState({
        popup: false,
        status: 'new',
        id: 0,
        secondaryID: 0,
        user_type: 0,
    })

    const toggleFullScreenPopup = (popup, status, id, sid) => {
        handleRedirectInternal(history, `seller/edit/${id}`)
    }
    const onClickEdit = (id, secondaryID, type) => {
        if (type === 'edit') {
            handleRedirectInternal(history, `seller/edit/${id}`)
        }
    }
    const onClickSellerEditNewTab = (id, secondaryID, type) => {
        if (type === 'edit') {
            window.open(`/seller/edit/${id}`, '_blank')
        }
    }

    const [tableValue, setTableValue] = useState([])
    const [searchInfo, setSearchInfo] = useState({})
    let action =
        props.match.params.action !== 'all'
            ? props.match.params.action === 'suspended'
                ? 'rejected'
                : props.match.params.action
            : null

    const custom = {
        action: {
            value: action,
            type: 'in',
            field: 'u.status',
        },
        admin: {
            value: '1',
            type: 'in',
            field: 'u.admin',
        },
    }

    useEffect(() => {
        if (user_tablefields && user_tablefields.length) {
            let dynamicValueAssign = {}
            let searchData = [...user_tablefields]
            let tableFields = [...user_tablefields]

            dynamicValueAssign.data = searchData
                .filter((item) => item.table_search === 1)
                .map((buscat) => {
                    return Object.assign(buscat, {
                        name: buscat.field,
                    })
                })
            tableFields.map((data) => {
                if (data.field === 'email') {
                    data.click = true
                    data.onclick = onClickSellerEditNewTab
                    data.clickID = 'id'
                    data.secondaryClickID = 'user_id'
                    data.clickType = 'edit'
                    data.type = 'hyperlink'
                }
            })
            let tableFiltered = []
            if (user_dynamicfields && user_dynamicfields.length) {
                let orgName = user_dynamicfields
                    .filter((item) => item.for_organization === 1)
                    .map((data) => {
                        return data.name
                    })
                console.log(orgName, 'orgnamess')
                tableFields.map((data) => {
                    if (
                        orgName.includes(data.field) ||
                        data.field == 'status' ||
                        data.field == 'last_login'
                    ) {
                        return tableFiltered.push(data)
                    }
                })
                console.log(tableFiltered, 'tableFilteres')
            }
            setTableValue(tableFiltered)
            setSearchInfo(dynamicValueAssign)
        }
    }, [user_tablefields, action, user_dynamicfields])

    return (
        <>
            <Layout>
                <div className="dashboard listing maillisting">
                    <div className="miscActions d-flex justify-content-start align-items-center flex-wrap mt-4">
                        <Button
                            id="org_add"
                            variant="outlined"
                            className="btnOutlined mr-2"
                            onClick={() =>
                                handleRedirectInternal(history, `seller/new/0`)
                            }
                        >
                            <span className="material-icons">
                                person_add_alt_1
                            </span>
                            Add New Seller
                        </Button>
                        <Button
                            id="org_report"
                            onClick={() =>
                                getAllExportDownload({
                                    action: 'export',
                                    order: 'asc',
                                    orderby: '',
                                    search: 'all',
                                    report: `${action}_seller_management`,
                                })
                            }
                        >
                            <span className="material-icons">get_app</span>
                            Export All Data
                        </Button>
                    </div>

                    <UserTableView
                        searchInfo={searchInfo}
                        customFilter={custom}
                        tableValue={tableValue}
                        toggleFullScreenPopup={toggleFullScreenPopup}
                        tableActionString={['active', 'deactivate']}
                        action={action}
                        listActionString={['switchuser']}
                        advFilters={true}
                        isEmp={true}
                    />
                </div>
                {/* <OrgManage data={manage} function={toggleFullScreenPopup} /> */}
            </Layout>
        </>
    )
}

export default UserCommon
